import { BaseTheme } from 'design-system';
import { useMemo } from 'react';
import { ButtonColor } from 'generated/graphql';

// Reusable hook to get button color
const useButtonColor = (theme: BaseTheme, color?: ButtonColor): string | null => {
  return useMemo(() => {
    if (!color) return null;
    switch (color.toLowerCase()) {
      case ButtonColor.Primary.toLowerCase():
        return theme.palette.primary.main;
      case ButtonColor.Secondary.toLowerCase():
        return theme.palette.secondary.main;
      case ButtonColor.Info.toLowerCase():
        return theme.palette.info.main;
      case ButtonColor.Warning.toLowerCase():
        return theme.palette.warning.main;
      case ButtonColor.Error.toLowerCase():
        return theme.palette.error.main;
      case ButtonColor.Success.toLowerCase():
        return theme.palette.success.main;
      default:
        return theme.palette.grey[400];
    }
  }, [theme, color]);
};

export default useButtonColor;
